module.exports = __webpack_public_path__ + "static/media/joop-homme-big.fde59ad2.png";